import type { InvoiceHistoryItem } from '../api/useInvoiceHistory';
import BankIcon from '@/shared/assets/document-icon.svg?react';
import { formatReceivedAmount } from '@/shared/lib';
import { DATE_FORMAT_DAY_TIME } from '@/shared/config';
import { formatInTimeZone } from 'date-fns-tz';

interface InvoiceItem extends InvoiceHistoryItem {
  bankName: string;
}

interface InvoiceHistoryContentProps {
  invoices: InvoiceItem[];
  onInvoiceClick?: (invoice: InvoiceItem) => void;
}

export function InvoiceHistoryContent({
  invoices,
  onInvoiceClick,
}: InvoiceHistoryContentProps) {
  const formatDate = (dateString: string) => {
    return formatInTimeZone(dateString, 'UTC', DATE_FORMAT_DAY_TIME);
  };

  return (
    <div className="h-full overflow-hidden py-[1.6rem] w-full bg-secondary-bg rounded-[1.6rem] flex flex-col flex-1">
      <div className="w-full  py-[1.6rem] space-y-[0.8rem] h-full overflow-y-auto my-[-1.6rem]">
        {invoices.map(invoice => (
          <div
            key={invoice.invoiceId}
            onClick={() => onInvoiceClick?.(invoice)}
            className="flex items-center gap-[2.4rem] px-[2.4rem] min-h-[5.6rem] hover:bg-stroke transition-colors cursor-pointer">
            <div className="flex-shrink-0">
              <BankIcon className="w-[2.4rem] h-[2.4rem] text-foreground" />
            </div>

            <div className="flex-1 flex flex-col gap-[0.4rem]">
              <div className="headline4 text-foreground">
                {invoice.bankName}
              </div>
              <div className="p5 text-muted-foreground">
                {formatDate(invoice.date)}
              </div>
            </div>

            <div className="flex items-center gap-[0.4rem]">
              <div className="headline4 text-foreground">
                {formatReceivedAmount(invoice.amount)}
              </div>
              <div className="headline4 text-foreground">
                {invoice.currencyCode}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
